import React from "react";

import facebook from "../img/facebook.jpg";
import github from "../img/github.png";
import linkedin from "../img/linkedin.png";

const time = new Date();
const year = time.getFullYear()

class Footer extends React.Component {
	render() {
		return (
			<div id="footer" className="container-fluid text-center py-5">
				<div className="container">
					<div className="row">
						<div className="col-12 col-sm-12 col-md-8 mx-auto">
							<a
								href="https://www.facebook.com/msadman"
								target="_blank"
								rel="noopener noreferrer">
								<img className="img-fluid" src={facebook} alt="" style={{height: 32,width: 32}}/>
							</a>
							<a
								className="px-3"
								href="https://github.com/kaneki666"
								target="_blank"
								rel="noopener noreferrer">
								<img src={github} alt=""/>
							</a>
							<a
								href="https://www.linkedin.com/in/mohammad-sadman-b85523190/"
								target="_blank"
								rel="noopener noreferrer">
								<img src={linkedin} alt=""/>
							</a>
						</div>
					</div>
		<h5 className="pt-4">Mohammad Sadman &copy;{year}</h5>
				</div>
			</div>
		);
	}
}

export default Footer;
